export default __webpack_public_path__ + "static/media/icon_chart_pyramid_white.ebbccd51.svg";